
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralWest as ObiBeaconGeneralWestElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-west.js';
 
 
 

 
 export const ObiBeaconGeneralWest = createComponent({
   react: React,
   tagName: 'obi-beacon-general-west',
   elementClass: ObiBeaconGeneralWestElement,
   events: {
     
   }
  });
 
 